import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { TextLineList } from "web_myplann/Shared/Components/TextLineList";
import type { EventRowLines } from "web_myplann/Shared/Types/EventRowLines";
import { clampLinesSx } from "web_myplann/Shared/Utils/sxUtils";

type Props = EventRowLines & {
	lineHeight?: number;
};

export const EventRowContent: FC<Props> = ({
	overline,
	title,
	variant,
	details,
	lineHeight,
}) => {
	const { palette, activity } = useTheme();

	return (
		<Stack flex={1} minWidth={0}>
			{overline && (
				<Typography
					variant="caption"
					color={palette.grey[500]}
					lineHeight={lineHeight}
					noWrap
				>
					{overline}
				</Typography>
			)}
			{title && (
				<Typography
					variant="bodyMedium"
					lineHeight={lineHeight}
					sx={{
						...clampLinesSx(activity.eventRow.titleLines[variant]),
						overflowWrap: "anywhere",
					}}
				>
					{title}
				</Typography>
			)}
			<TextLineList lines={details} lineHeight={lineHeight} />
		</Stack>
	);
};
